export enum MenuLinkTypeDTO {
    SINGLE_ORGANISER = 'SINGLE_ORGANISER',
    PER_COVER = 'PER_COVER'
}
